define(
    'IMEIManager',
    [
        'IMEIManager.List.View',
        'IMEIManager.Helper'
    ],
    function (
        IMEIManagerListView,
        IMEIManagerHelp
    ) {

        return {

            mountToApp: function mountToApp(container) {

                var layout = container.getComponent('Layout');
                var plp = container.getComponent('PLP');

                if (layout) {

                    layout.addChildView('Product.Options', function () {
                        return new IMEIManagerListView({
                            container: container
                        });
                    });
                }

                if (plp) {
                    plp.on('afterShowContent', function () {
                        var queryString = window.location.search;
                        var urlParams = new URLSearchParams(queryString);

                        IMEIManagerHelp.addIMEIs(urlParams.get('imei'));

                    })
                }
            }
        }

    });
